import React from "react";
import styled, { css } from "styled-components";
import withData from "../withData";
import Gettext, { withGettext } from "../common/Gettext";
import { withMoney } from "../Money";
import { fontSize } from "../common/styled-mixins";

import ReferralsShareLinks from "../ReferralsShareLinks";
import CopyIcon from "../Icons/Copy";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 40px;

  ${({ isPopup }) =>
    isPopup &&
    css`
      margin-top: 20px;
      padding-bottom: 10px;
    `};
`;

const Title = styled.h3`
  margin-right: 10px;
  font-size: ${fontSize(14)};
  color: ${({ theme, isPopup }) =>
    theme.mode === "dark" || !isPopup ? "#ffffff" : "#feac00"};

  @media (max-width: 579px) {
    width: 110px;
    text-align: right;
  }
`;

const List = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 579px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Item = styled.div`
  display: flex;
  align-items: center;

  ${({ type }) =>
    type === "socialShare" &&
    css`
      margin-right: 68px;

      @media (max-width: 579px) {
        margin-right: 0;
        margin-bottom: 20px;
      }
    `};
`;

const CopyUrlButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 49px;
  height: 49px;
  background-color: #3b9478;
  border-radius: 50%;
  cursor: pointer;
`;

const CopyIconContainer = styled.div`
  color: #ffffff;
`;

const ShareTournament = ({
  title,
  currentPlace,
  prize,
  profile,
  prizePlacesCount,
  tournamentId,
  isPopup,
  ...props
}) => {
  if (!profile || !currentPlace) {
    return null;
  }

  const referalLink = profile.ref_bonus.link;

  function copyUrl() {
    const temporaryInput = document.createElement("INPUT");
    const tournamentLink = `${
      window.location.origin
    }/tournaments/${tournamentId}`;

    temporaryInput.value = process.env.REACT_APP_DEPLOY_TARGET === "irontrade" ? tournamentLink +
      " " +
      props.gettext(["I earn ", " in \"", "\" tournament on IronTrade! Register by my referal link ", ", trade, invest and try tournaments!"], props.money(prize), title, referalLink) : "";
    document.body.appendChild(temporaryInput);
    temporaryInput.select();
    document.execCommand("copy");
    document.body.removeChild(temporaryInput);
  }

  return currentPlace <= prizePlacesCount ? (
    <Wrapper isPopup={isPopup}>
      <List>
        <Item type="socialShare">
          <Title isPopup={isPopup}>
            <Gettext>Share results</Gettext>:
          </Title>
          <ReferralsShareLinks
            isTournament
            prize={props.money(prize)}
            tournamentTitle={title}
            link={referalLink}
          />
        </Item>
        <Item>
          <Title isPopup={isPopup}>
            <Gettext>Copy link</Gettext>:
          </Title>
          <CopyUrlButton onClick={copyUrl}>
            <CopyIconContainer>
              <CopyIcon />
            </CopyIconContainer>
          </CopyUrlButton>
        </Item>
      </List>
    </Wrapper>
  ) : null;
};

export default withData({
  optional: ["profile"]
})(withGettext(withMoney(ShareTournament)));



// WEBPACK FOOTER //
// ./src/components/Tournament/ShareTournament.js